import script from "./my-property.vue?vue&type=script&setup=true&lang=js"
export * from "./my-property.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__